// public/js/modules/map/state.js
// State for the MapLibre (map) implementation

export let mapInstance = null;                 // maplibregl.Map
export const markers = new Map();              // assetUUID → maplibregl.Marker
export let markerClusterer = null;             // not used the same way; we manage clustering ourselves
export let currentFilteredAssets = [];
export let currentOpenPopup = null;            // maplibregl.Popup
export let currentHistoryPointMarkers = [];    // maplibregl.Marker[]
export let currentRouteLayers = [];            // track layer ids we added for history
export let currentRouteSourceIds = [];         // track source ids for history
export let currentHistoryPoints = [];          // full history points (with sensor fields) for the chart sidebar

// ==================== SETTER ====================
export function setMapInstance(map) { mapInstance = map; }
export function setMarkerClusterer(clusterer) { markerClusterer = clusterer; }
export function setCurrentFilteredAssets(assets) { currentFilteredAssets = assets || []; }
export function setCurrentOpenPopup(popup) { currentOpenPopup = popup; }
export function setCurrentHistoryPointMarkers(markersArr) { currentHistoryPointMarkers = markersArr || []; }
export function setCurrentRouteLayers(layers) { currentRouteLayers = layers || []; }
export function setCurrentRouteSourceIds(sources) { currentRouteSourceIds = sources || []; }
export function setCurrentHistoryPoints(points) { currentHistoryPoints = points || []; }

export function resetState() {
  mapInstance = null;
  markers.clear();
  markerClusterer = null;
  currentFilteredAssets = [];
  currentOpenPopup = null;
  currentHistoryPointMarkers = [];
  currentRouteLayers = [];
  currentRouteSourceIds = [];
  currentHistoryPoints = [];
}

// Helper to close any open popup
export function closeCurrentPopup() {
  if (currentOpenPopup) {
    try { currentOpenPopup.remove(); } catch (e) {}
    currentOpenPopup = null;
  }
}
